import { useContext } from 'react';
import { ActivesContextWallet } from '../Context/ActivesContext';

export function useActivesWallet() {
  const context = useContext(ActivesContextWallet);

  return context;
}
